<template>
   <Icon v-if="params.value" name="check-circle" class="text-[#2e8f2e]" />
   <Icon v-else name="close" class="text-red" />
</template>

<script lang="ts" setup>
import type { BooleanCellParams, GridCellProps } from '~/composables/grid/cell-params'

defineProps<GridCellProps<BooleanCellParams>>()
</script>
